// extracted by mini-css-extract-plugin
export default {"cardContent":"register-intro_cardContent__ECg8q","cardButton":"register-intro_cardButton__OdXOo"};